import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { formatDayLabel } from '@repo/date-time';
import SummaryRow from '../SummaryRow';
import { getLabels } from '../../labels';
export default function ParkingInformationOpeningHoursDisplay({ openingHours, testId }) {
    return (_jsx(SummaryRow, { label: getLabels().parking_information.opening_hours.label, children: _jsx("div", { className: "text-heading flex flex-col items-end text-sm leading-5 font-medium", "data-testid": testId.append('list'), children: openingHours.map((hour, index) => (_jsxs("span", { "data-testid": testId.append('row').append(index.toString()), children: [formatDayLabel(hour.day), ' ', hour.isFullDay
                        ? getLabels().parking_information.opening_hours.open_24h
                        : `${hour.startHour ?? ''} - ${hour.endHour ?? ''}`] }, index))) }) }));
}
